var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copy-right"},[_c('p',[_vm._v("主办：浙江省消防救援总队 ")])])
}]

export { render, staticRenderFns }